// extracted by mini-css-extract-plugin
export default {"container":"summary-title_container__YTlj0"};